// you can import modules from the theme lib or even from
// NPM packages if they support it…
// import ExampleComponent1 from "./components/mobile-toggle.vue";
// import ExampleComponent2 from "./components/example-2.js";

// // you can also require modules if they support it…
// const ExampleModule1 = require('./components/mobile-toggle.vue');
// const ExampleModule2 = require('./components/example-2.js');

// // Some convenient tools to get you started…
// import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
// import AnimateOnPageLinks from "./components/AnimateOnPageLinks";


// Initialise our components on jQuery.ready…
// jQuery(function ($) {
//     ExampleComponent1.init();
//     ExampleModule2.init();
//     ReplaceObfuscatedEmailAddresses.init();
//     AnimateOnPageLinks.init();
// });

// Vue.js
new Vue({
    el: "#app",
    data: {
        form: [],
        opened: false,
        search: false,
        searchDesktop: false,
        account: false,
        cartPopUpOpen: false,
        filterOpen: false,
        reviewOpen: false,
        textFull: false,
        descriptionExpand: false,
        specificationsExpand: false,
        couponExpand: false,
        checkoutCompany: false,
        checkoutShipping: false,
        checkoutEditBusiness: false,
        checkoutEditPersonal: false,
        checkoutEditBilling: false,
        checkoutEditShipping: false,
        checkoutEditComments: false,
        password: null,
        showPassword: false,
        demo: false,
        supportPopUp: false,
        videoPlay: false,
        checkoutToggle: false,
        activetab: 1,
        activeStand: 1,
        activeCompetitieStand: null,
        activePeriodeStand: 0,
        activeProgram: 0,
        activeResults: 0,
        current: null,
        subtab: 0,
        isPlaying: false,
        teamcode: null,

        billing_zipcode: '',
        billing_street: '',
        billing_housenumber: '',
        billing_city: '',
        billing_outputzipcode: '',
        billing_addresEdit: false,
        billing_error: false,

        shipping_zipcode: '',
        shipping_street: '',
        shipping_housenumber: '',
        shipping_city: '',
        shipping_outputzipcode: '',
        shipping_addresEdit: false,
        shipping_error: false,
    },
    watch: {

        billing_zipcode: function(){
            this.billing_city = '';

            if (this.billing_zipcode.length >= 6 && this.billing_housenumber){
                this.BillingLookupZip()
            }
        },
        billing_housenumber: function(){
            this.billing_city = '';

            if (this.billing_zipcode.length >= 6 && this.billing_housenumber){
                this.BillingLookupZip()
            }
        },
        shipping_zipcode: function(){
            if (this.shipping_zipcode.length >= 6 && this.shipping_housenumber){
                this.ShippingLookupZip()
            }
        },
        shipping_housenumber: function(){
            if (this.shipping_zipcode.length >= 6 && this.shipping_housenumber){
                this.ShippingLookupZip()
            }
        }
    },
    computed: {
        audioUrl() {
            const protocol = window.location.protocol;
            const hostname = window.location.hostname;
    
            return `${protocol}//${hostname}/wp-content/themes/elburger-sc/assets/audio/clublied.mp3`;
        },
    
    },
    mounted() {

        this.checkHash();
        window.addEventListener('hashchange', this.checkHash); // Update on hash change

        this.audio = new Audio(this.audioUrl);

            this.audio.onplay = () => {
            this.isPlaying = true;
        };
            this.audio.onpause = () => {
            this.isPlaying = false;
        };
            this.audio.onended = () => {
            this.isPlaying = false;
        };

    },
    beforeDestroy() {
        window.removeEventListener('hashchange', this.checkHash);
    },
    methods: {
        handleClick() {
            this.scrollToStand(); // Roep daarna de scrollfunctie aan
            this.activetab = 5;  // Zet de actieve tab eerst
            
        },
        scrollToStand() {
            const element = document.querySelector("#stand-overview");
            if (element) {
            window.scrollTo({
                top: element.offsetTop,
                behavior: "smooth"
            });
            }
        },

        checkHash() {
            if (window.location.hash === '#selectie') this.activetab = 1;
            if (window.location.hash === '#nieuws') this.activetab = 2;
            if (window.location.hash === '#programma') this.activetab = 3;
            if (window.location.hash === '#uitslagen') this.activetab = 4;
            if (window.location.hash === '#stand') this.activetab = 5;
            if (window.location.hash === '#foto') this.activetab = 6;
            if (window.location.hash === '#contact') this.activetab = 7;
        },
        toggleSound() {
            if (!this.audio) return;

            if (this.audio.paused) {
                this.audio.play();
            } else {
                this.audio.pause();
            }
        },
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
        setFocus() {
            this.$refs.search.focus();
        },
        toggleSubtab(i) {
            this.subtab = this.subtab === i ? null : i;
        },
        BillingLookupZip() {
            var _this               = this;
            var billing_zipcode     = _this.billing_zipcode.replace(/\s/g, '');
            var billing_housenumber = _this.billing_housenumber;

            axios.get('https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?fq=postcode:' + billing_zipcode + '&fq=' + billing_housenumber )
            .then(function (output){
                _this.billing_error             = false;
                _this.billing_city              = output.data.response.docs[0].woonplaatsnaam;
                _this.billing_street            = output.data.response.docs[0].straatnaam;
                _this.billing_outputzipcode     = output.data.response.docs[0].postcode;

            })
            .catch(function (error){
                _this.billing_error             = true;
                _this.billing_city              = "";
                _this.billing_street            = "";
                _this.billing_outputzipcode     = "";

            })
        },
        ShippingLookupZip() {
            var _this               = this;
            var shipping_zipcode     = _this.shipping_zipcode.replace(/\s/g, '');
            var shipping_housenumber = _this.shipping_housenumber;

            axios.get('https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?fq=postcode:' + shipping_zipcode + '&fq=' + shipping_housenumber )
            .then(function (output){
                _this.shipping_error             = false;
                _this.shipping_city              = output.data.response.docs[0].woonplaatsnaam;
                _this.shipping_street            = output.data.response.docs[0].straatnaam;
                _this.shipping_outputzipcode     = output.data.response.docs[0].postcode;

            })
            .catch(function (error){
                _this.shipping_error             = true;
                _this.shipping_city              = "";
                _this.shipping_street            = "";
                _this.shipping_outputzipcode     = "";

            })
        }
        

    }

})


jQuery(document).ready(function() {
    jQuery('.contact-item').click(function() {
        jQuery('html, body').animate({
            scrollTop: jQuery("#commissies").offset().top
        }, 500);

        var $this   = jQuery(this);
        var $index   = $this.index();
    
        jQuery('.contact-item').removeClass('font-bold text-primary-blue-light');
        $this.addClass('font-bold text-primary-blue-light');
    
        jQuery('.contact-content').removeClass('activeImportantFlex');
        jQuery('.contact-content').eq($index).addClass('activeImportantFlex');
    
    });
});


function init() {

    // Sliders
    var imagesThumb = new Swiper('.image-thumbs', {
        direction: 'horizontal',
        slidesPerView: 6,
        spaceBetween: 10,
        shortSwipes: false,
        watchSlidesVisibility: false,
        breakpoints: {
            540: {
                slidesPerView: 8,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            1024: {
                direction: 'horizontal',
                slidesPerView: 6,
                spaceBetween: 10,
                slideToClickedSlide: true,
                allowTouchMove: true,
                shortSwipes: false,
                touchStartPreventDefault: false,
                touchRatio: 0
            },
        }
    });

    var imagesSlide = new Swiper('.image-slider', {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 20,
        loop: false,
        grabCursor: false,
        arrows: true,
        longSwipesRatio: 0.05,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        thumbs: {
            swiper: imagesThumb
        },
        normalizeSlideIndex: false,
        breakpoints: {
            1024: {
                allowTouchMove: false
            },
        }
    });

    var pageSlide = new Swiper('.page-slider', {
        slidesPerView: 1.75,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        breakpoints: {
            640: {
                slidesPerView: 2.25,
            },
            840: {
                slidesPerView: 3.25,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        }

    });

    var productSlide = new Swiper('.product-slider', {
        slidesPerView: 1.5,
        freeMode: true,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        shortSwipes: false,
        // longSwipesRatio: 0.05,
        speed: 300,
        navigation: {
            nextEl: '.button-next-products',
            prevEl: '.button-prev-products',
        },
        breakpoints: {
            480: {
                slidesPerView: 1.75,
                freeMode: true
            },
            640: {
                slidesPerView: 2.55,
                freeMode: true
            },
            768: {
                slidesPerView: 2.75,
                freeMode: true
            },
            960: {
                slidesPerView: 3.25,
                freeMode: true
            },
            1024: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 15,
                freeMode: true
            },
            1180: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 15,
                allowTouchMove: false
            },
            1600: {
                slidesPerView: 5,
                slidesPerGroup: 5,
            }
        }
    });
    
    var homeSlide = new Swiper('.home-product-slider', {
        slidesPerView: 1.5,
        freeMode: true,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        shortSwipes: false,
        // longSwipesRatio: 0.05,
        speed: 300,
        navigation: {
            nextEl: '.button-next-products',
            prevEl: '.button-prev-products',
        },
        breakpoints: {
            480: {
                slidesPerView: 1.75,
                freeMode: true
            },
            640: {
                slidesPerView: 2.55,
                freeMode: true
            },
            768: {
                slidesPerView: 2,
                freeMode: true
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 15,
                freeMode: true
            },
            1180: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 15,
                allowTouchMove: false
            },
            1600: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            }
        }
    });


    var thumbSlide = new Swiper('.thumb-slider', {
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        arrows: true,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 3.25,
            },
            1024: {
                slidesPerView: 3.75,
                slidesPerGroup: 3.75,
                allowTouchMove: false
            }
        }
    });

    var categorySlide1 = new Swiper('.image-category-slider', {
        slidesPerView: 2.2,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        freeMode: true,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2.75,
                slidesPerGroup: 2.75,
            },
            768: {
                slidesPerView: 3.5,
                slidesPerGroup: 3.5,
            },
            1024: {
                slidesPerView: 5.25,
                freeMode: false,
                slidesPerGroup: 5.25,
                allowTouchMove: true
            }
        }
    });

    var categorySlide2 = new Swiper('.category-slider', {
        slidesPerView: 1.25,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        // freeMode: true,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 1.75,
            },
            600: {
                slidesPerView: 2.25,
            },
            768: {
                slidesPerView: 2.75,
                slidesPerGroup: 2.75,
                freeMode: true,
            },
            960: {
                slidesPerView: 2.75,
                slidesPerGroup: 2.75,
                freeMode: true,
            },
            1024: {
                slidesPerView: 3.15,
                freeMode: false,
                slidesPerGroup: 3,
                allowTouchMove: true
            },
            1600: {
                slidesPerView: 4.15,
                freeMode: false,
                slidesPerGroup: 4,
            }
        }
    });

    var cardSlider = new Swiper('.card-slider', {
        slidesPerView: 1.25,
        centeredSlides: false,
        spaceBetween: 20,
        loop: false,
        grabCursor: false,
        freeMode: true,
        breakpoints: {
            480: {
                slidesPerView: 1.5,
            },
            600: {
                slidesPerView: 1.75,
            },
            768: {
                slidesPerView: 2.25,
            },
            1024: {
                freeMode: false,
                spaceBetween: 20,
                slidesPerView: 3,
            }
        }
    });

    var accountSlider = new Swiper('.account-slider', {
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 5,
        loop: false,
        grabCursor: false,
        freeMode: true,
        
    });

    var logoSlider = new Swiper('.logo-slider', {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 10,
        loop: true,
        grabCursor: false,
        freeMode: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            slidesPerGroup: 8,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.button-logo-next',
            prevEl: '.button-logo-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
            600: {
                centeredSlides: false,
                slidesPerView: 6,
                slidesPerGroup: 6,
                spaceBetween: 20,
            },
            1024: {
                spaceBetween: 30,
                freeMode: false,
                centeredSlides: false,
                slidesPerView: 6,
                slidesPerGroup: 3,
            },
            1920: {
                spaceBetween: 30,
                slidesPerView: 6,
                slidesPerGroup: 3,
            }
        }
    });

    var trustpilotSlide = new Swiper('.trustpilot-slider', {
        slidesPerView: 1.5,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        arrows: true,
        navigation: {
            nextEl: '.btn-next',
            prevEl: '.btn-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 2.15,
            },
            800: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 30,
                allowTouchMove: false,
                slidesPerGroup: 3,
            }
        }
    });

    var pricingSlide = new Swiper('.pricing-slider', {
        slidesPerView: 1.35,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        breakpoints: {
            500: {
                slidesPerView: 1.5,
            },
            640: {
                slidesPerView: 2.1,
            },
            840: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
                allowTouchMove: false,
            },
        }

    });


    var uspSlider = new Swiper('.usp-slider', {
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 20,
    });

    let cart_settings = {
        slidesPerView: 1.5,
        freeMode: true,
        centeredSlides: false,
        spaceBetween: 10,
        loop: false,
        grabCursor: false,
        shortSwipes: false,
        longSwipesRatio: 0.05,
        speed: 700,
        navigation: {
            nextEl: '.button-next-products',
            prevEl: '.button-prev-products',
        },
        breakpoints: {
            480: {
                slidesPerView: 1.75,
                freeMode: true
            },
            640: {
                slidesPerView: 2.55,
                freeMode: true
            },
            768: {
                slidesPerView: 2.75,
                freeMode: true
            },
            960: {
                slidesPerView: 2.75,
                freeMode: true
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1200: {
                slidesPerView: 2.25,
                slidesPerGroup: 3,
                allowTouchMove: false,
            }
        }
    }

    jQuery(document.body).on('removed_from_cart updated_cart_totals', function () {

        var cartSlider = new Swiper('.cart-slider', cart_settings);

    });
    var cartSlider = new Swiper('.cart-slider', cart_settings);

    


    // Quantity plus or down value
    jQuery(function($) {

        jQuery(document).ready(function($) {
            if (typeof tinyMCE !== "undefined") {
                setTimeout(function() {
                    jQuery(".wp-switch-editor.switch-tmce").click();
                }, 500); // Wacht even om te zorgen dat de editor geladen is
            }
        });
        


        setInterval(function() {

            var value_qty       = jQuery('.qty').val();
            var value_min_qty   = jQuery('.qty').attr('min');
            var value_max_qty   = jQuery('.qty').attr('max');

            // Disable down button
            if(value_qty == value_min_qty) {
                jQuery('.qty-down').addClass('text-gray-400');
                jQuery('.qty-down').removeClass('text-black hover:text-gray-500');
            }
            else {
                jQuery('.qty-down').removeClass('text-gray-400');
                jQuery('.qty-down').addClass('text-black hover:text-gray-500');
            }

            // Disable up button
            if(value_qty == value_max_qty) {
                jQuery('.qty-up').addClass('text-gray-400');
                jQuery('.qty-up').removeClass('text-black hover:text-gray-500');
            }
            else {
                jQuery('.qty-up').removeClass('text-gray-400');
                jQuery('.qty-up').addClass('text-black hover:text-gray-500');
            }

        }, 0);


        jQuery(document).on("click", ".qty-toggle", function () {

            var $button     = $(this);
            var qtyItem     = $button.closest('.qty-item');
            var oldValue    = qtyItem.find('.qty').val();
            var attrButton  = $button.attr('data-id');
            var attrMin     = qtyItem.find('.qty').attr('min');
            var attrMax     = qtyItem.find('.qty').attr('max');

            if (attrButton == "plus") {
                if(parseInt(oldValue) < parseInt(attrMax)) {
                    var newVal = parseFloat(oldValue) + 1;
                }

            }
            if (attrButton == "min") {
                if(parseInt(oldValue) > parseInt(attrMin)) {
                   if (oldValue > 0) {
                        var newVal = parseFloat(oldValue) - 1;
                    } else {
                        newVal = 1;
                    }
                }
            }
            if(newVal) $button.closest('.qty-item').find('.qty').val(newVal).change();

        });
    });


    let oldValue = 0;

    // window.addEventListener('scroll', function(e){
    //     var element     = document.getElementById("mobile-menu");

    //     if (element !== null) {
    //         // Get the new Value
    //         newValue = window.pageYOffset;

    //         //Subtract the two and conclude
    //         if(newValue >= 20) element.classList.add("shadow-menu");
    //         if(newValue <= 20) element.classList.remove("shadow-menu");

    //         // Update the old value
    //         oldValue = newValue;
    //     }
    // });

    
    // YouTube video
    jQuery('.video').click(function(event) {
        var video       = jQuery('.video').find('iframe');
        var video_src   = jQuery('.video').find('iframe').attr('src');

        var video_url   = video_src + '&autoplay=1';

        video.attr('src', video_url);
    });

    // Loader
    var intervalId = window.setInterval(function(){
      var searchFilter  = jQuery('.search-filter-results');
      var productLoader = jQuery('.product-loader');

      if(searchFilter.length) {
        var positionLeft  = searchFilter.offset().left;
        var elementWidth  = searchFilter.width() / 2;
        var elementheight   = jQuery(window).height() / 2;
        var sum       = positionLeft + elementWidth;
        productLoader.css({
          'left' : sum + 'px',
          'top' : elementheight + 'px',
        });
      }

    }, 100);

    // Coupon click
    jQuery(document).on('click','#couponButton', function(event){
        jQuery(".coupon").css('display', 'flex');
    });

    // Menu click
    jQuery(document).on('click','.menu-item-has-children a', function(event){

        if (jQuery(window).width() <= 1024) {

            if(jQuery(this).next().length > 0) {
                var item = jQuery(this).next().find('.mobile-menu-items'); 
                
                if(item.find('.menu-depth-prev').length == 0) {
                    var text = jQuery(this).text(); 
                    item.prepend('<div class="flex flex-row menu-depth-prev w-full py-4 px-6 text-sm font-bold border-b border-white-transparent cursor-pointer"><svg class="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M1.293,12.707a1,1,0,0,1,0-1.414l6-6A1,1,0,0,1,8.707,6.707L4.414,11H22a1,1,0,0,1,0,2H4.414l4.293,4.293a1,1,0,0,1-1.414,1.414Z"/></svg><span class="menu-depth-prev-text uppercase">' +  text + '</span></div>');                
                }

                jQuery(this).next().addClass('active-menu');
                event.preventDefault();
            }
                
        } 

    });


    // Menu remove click
    jQuery(document).on('click','.menu-depth-prev', function(event){
        jQuery(this).closest('.sub-menu').removeClass('active-menu');
    });
    jQuery(document).on('click','.background-menu-active, .close-icon', function(event){
        jQuery('.sub-menu').removeClass('active-menu');    
    });


    var distance        = jQuery('.divider-place-order');
    if(distance.length) {

        distance = jQuery('.divider-place-order').offset().top

        var className;
        var classMobile     = 'fixed bottom-0 left-0 md:relative w-full bg-white md:bg-transparent p-4 md:p-0 shadow-checkout md:shadow-none duration-300';
        var classDesktop    = 'relative w-full mt-4 md:hidden duration-300';

        var windowHeight = jQuery(window).height();

        if(jQuery(window).width() < 768) className = classMobile;
        if(jQuery(window).width() >= 768) className = classDesktop;

        if(jQuery(window).width() < 768) {
            jQuery(window).scroll(function () {
                var sum = Number(distance) - Number(windowHeight);

                console.log('scroll: ' + jQuery(window).scrollTop() + ' - Positie: ' + sum);

                if (jQuery(window).scrollTop() >= sum) className = classDesktop;
                if (jQuery(window).scrollTop() <= sum) className = classMobile;

                jQuery('#place_order_section').removeClass();
                jQuery('#place_order_section').addClass(className);
            });
        }
    }

}
// function lightGalleryInit() {
//     const lightGalleryElement = document.getElementById('lightgallery');
//     if (lightGalleryElement) {
//         lightGallery(lightGalleryElement, {
//             videojs: true,
//             thumbnail: true,
//             animateThumb: false,
//             showThumbByDefault: true,
//             download: true
//         });
//     }
    
//     const lightGalleryPlayerElement = document.getElementById('lightgalleryplayer');
//     if (lightGalleryPlayerElement) {
//         lightGallery(lightGalleryPlayerElement, {
//             videojs: true,
//             thumbnail: true,
//             animateThumb: false,
//             showThumbByDefault: true,
//             download: true
//         });
//     }
// }


// lightGalleryInit();
init();


(function () {
    function warn(msg){ if (console && console.warn) console.warn(msg); }
    function hasLG(){ return typeof window.lightGallery === "function"; }
  
    const defaultOptions = {
      download: true,
      thumbnail: true,
      animateThumb: false,
      showThumbByDefault: true,
      videojs: true
    };
  
    function collectPlugins() {
      const p = [];
      if (window.lgZoom) p.push(window.lgZoom);
      if (window.lgThumbnail) p.push(window.lgThumbnail);
      if (window.lgVideo) p.push(window.lgVideo);
      if (window.lgFullscreen) p.push(window.lgFullscreen);
      if (window.lgAutoplay) p.push(window.lgAutoplay);
      return p;
    }
  
    function parseDataset(el) {
      const out = {};
      for (const [k, v] of Object.entries(el.dataset || {})) {
        if (v === "true") out[k] = true;
        else if (v === "false") out[k] = false;
        else if (!Number.isNaN(Number(v))) out[k] = Number(v);
        else out[k] = v;
      }
      return out;
    }
  
    function destroyIfExists(el) {
      if (el && el.lg && typeof el.lg.destroy === "function") el.lg.destroy(true);
    }
  
    function initOne(el, extraOptions = {}) {
      destroyIfExists(el);
      const plugins = collectPlugins();
      const finalOptions = { ...defaultOptions, ...parseDataset(el), ...extraOptions };
      if (plugins.length) finalOptions.plugins = plugins;
      el.lg = window.lightGallery(el, finalOptions);
      return el.lg;
    }
  
    function initAll() {
      if (!hasLG()) {
        warn("[lightGalleryInit] lightGallery niet gevonden. Laad eerst de core + plugins.");
        return [];
      }
      const nodes = document.querySelectorAll(".js-lightgallery, #lightgallery, #lightgalleryplayer");
      const uniq = Array.from(new Set(nodes)); // geen dubbel init
      return uniq.map(el => initOne(el));
    }
  
    // Exporteer voor handmatige re-init (bijv. na AJAX)
    window.lightGalleryInit = initAll;
  
    // Auto-init
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        initAll();
        if (typeof window.init === "function") window.init();
      });
    } else {
      initAll();
      if (typeof window.init === "function") window.init();
    }
  })();



let elementsArray = document.querySelectorAll(".animated-fade");
console.log(elementsArray);
window.addEventListener('scroll', fadeIn); 
function fadeIn() {
    for (var i = 0; i < elementsArray.length; i++) {
        (function(i) {
            setTimeout(function() {
                var elem = elementsArray[i];
                var distInView = elem.getBoundingClientRect().top - window.innerHeight + 20;
                if (distInView < 0) {
                    elem.classList.add("inView");
                } else {
                    elem.classList.remove("inView");
                }
            }, i * 100);
        })(i);
    }
}
fadeIn();













